import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';
import { ReactComponent as AlertIcon } from 'assets/icons/alert-triangle.svg';
import { REJECTION_TYPES } from 'constants/digitalLoan';

const RejectionSheet = ({ type, literals, onUnderstood }) => {
  const content = literals[type] || literals.applicability;

  return (
    <Modal
      className='digital-loan-rejection-sheet-modal'
      position='end'
      animation='slide-up-enter'
      closeOnBackgroundClick={false}
      showCloseButton={false}
      onClose={() => {}}
    >
      <div className='digital-loan-rejection-sheet'>
        <div className='digital-loan-rejection-sheet__badge-wrap'>
          <div className='digital-loan-rejection-sheet__badge'>
            <AlertIcon aria-hidden='true' />
          </div>
        </div>
        <h2 className='digital-loan-rejection-sheet__title'>{content.title}</h2>
        <p className='digital-loan-rejection-sheet__body'>{content.body}</p>
        {content.bodySecondary && (
          <p className='digital-loan-rejection-sheet__body'>{content.bodySecondary}</p>
        )}
        <p className='digital-loan-rejection-sheet__website'>
          {content.websiteIntro}
          {' '}
          <strong>{content.websiteLabel}</strong>
        </p>
        <div className='digital-loan-rejection-sheet__actions'>
          <Button text={literals.understood} onClick={onUnderstood} />
        </div>
      </div>
    </Modal>
  );
};

RejectionSheet.propTypes = {
  type: PropTypes.oneOf(Object.values(REJECTION_TYPES)).isRequired,
  literals: PropTypes.object.isRequired,
  onUnderstood: PropTypes.func.isRequired,
};

export default RejectionSheet;
